export default __webpack_public_path__ + "static/media/green.1eb61545.svg";